import { render } from "./formContact.vue?vue&type=template&id=9c4a808e"
import script from "./formContact.vue?vue&type=script&lang=js"
export * from "./formContact.vue?vue&type=script&lang=js"

import "./formContact.vue?vue&type=style&index=0&id=9c4a808e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__